import { Component, Input, OnInit, SimpleChange } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'user-avatar-name',
    imports:[MatTooltipModule],
    template: `
    
    <span [matTooltip]="name"
        class="whitespace-nowrap text-sm uppercase w-8 h-8 flex items-center justify-center bg-[#23addb] text-white rounded-full">
        {{ safeName.charAt(0) + safeName.charAt(1) }}
    </span>
    
   `
})

export class UserAvatarWidgetComponent implements OnInit {
    @Input() name: string | null = '';
    safeName: string = '';

    constructor() { }
    ngOnInit(): void {
        
    }

    ngOnChanges(changes: SimpleChange): void {
        if (changes['name']) {
          this.safeName = this.getInitials(this.name);
        }
      }

    getInitials(name: string | null): string {
        if (!name) return '';
        const words = name.trim().split(' ').filter(w => w.length > 0);
        const initials = words.slice(0, 2).map(word => word.charAt(0).toUpperCase()).join(''); 
        return initials || '';
    }
}